import type { BaseDictionaryItem } from './dictionaryUtils'

export interface CallAgentBadgeItem extends BaseDictionaryItem {
  ringColor?: string
  iconColor?: string
  localePluralIndex?: number
}

export const CALL_AGENT_BADGES: readonly CallAgentBadgeItem[] = [
  {
    key: 'streak',
    label: 'Streak',
    localeKey: 'ui.gamification.badges.streak',
    ringColor: '#FFA57E',
    icon: 'flame',
    iconColor: '#F9782F'
  },
  {
    key: 'achievements',
    label: 'Achievement',
    localeKey: 'ui.gamification.badges.achievement',
    localePluralIndex: 2,
    ringColor: '#FFDCA7',
    icon: 'medal',
    iconColor: '#FFC874'
  },
  {
    key: 'leaderboard',
    label: 'Leaderboard',
    localeKey: 'ui.gamification.badges.leaderboard',
    ringColor: '#799DDE',
    icon: 'wreath-laurel',
    iconColor: '#799DDE'
  },
  { key: 'ERROR', label: 'ERROR', localeKey: 'dev.dataMappingError', icon: 'bug', color: 'error' }
] as const
